export default __webpack_public_path__ + "static/media/Head_4_Ear_3_C3.7485bff1.svg";